import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '@tcp/core/src/components/common/molecules/Carousel/views/Carousel';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles, { StyledOutfitImage } from '../styles/OutfitCarousel.style';

const TouchSlider = ({ selectedProductsLists, setCurrentImageIndex, className }) => {
  const CAROUSEL_OPTIONS = {
    className: 'center',
    infinite: false,
    swipe: true,
    slide: true,
    swipeToSlide: true,
    touchMove: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: (current) => setCurrentImageIndex(current),
    responsive: [
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
        },
      },
    ],
  };
  return (
    <div className={className}>
      <Carousel
        className={`outfit-carousel`}
        options={{ ...CAROUSEL_OPTIONS }}
        carouselConfig={{ arrows: false }}
      >
        {selectedProductsLists?.map((product) => (
          <StyledOutfitImage
            src={product?.image_url || product?.imageUrl}
            alt={`outfit`}
            key={`${product.id}`}
          />
        ))}
      </Carousel>
    </div>
  );
};

export default withStyles(TouchSlider, styles);

TouchSlider.propTypes = {
  selectedProductsLists: PropTypes.shape([]),
  setCurrentImageIndex: PropTypes.func,
  className: PropTypes.string,
};

TouchSlider.defaultProps = {
  selectedProductsLists: [],
  setCurrentImageIndex: () => {},
  className: '',
};
